export default "__VITE_ASSET__GzSlNSiQ__"